import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { getFilesMultiPrefixesReq } from '../services/api';

function Avatar(props) {
  const {
    classes: {
      profilePic,
    },
    providerId,
    onClick,
    /* refreshImgHook: a hook to rerender the Avatar comp. and refresh the
     profile pic upon hook change. */
    refreshImgHook,  

    /* customStyles: pass a styles object inorder to custom the component css. */
    customStyles,
    className,
  } = props;

  const [imgDataUrl, setImgDataUrl] = useState();

  useEffect(() => {
    if(providerId){
      loadProfilePic(providerId);
    }
  }, [refreshImgHook, providerId]);

  const loadProfilePic = async providerId => {
    const croppedPrefix = `profile-pictures/${providerId}-cropped`
    const defAvatarPrefix = `profile-pictures/default-avatar`
    try{
      const [cropRes, avatarRes] = await getFilesMultiPrefixesReq([croppedPrefix, defAvatarPrefix]);
      const {dataUrl} = cropRes.length === 0? avatarRes[0] : cropRes[0];
      setImgDataUrl(dataUrl);
      return;
    }catch(error){
      console.error('Error fetching pic from S3:', error);
    }
  }
  
  return imgDataUrl ? (
    <img
      src={imgDataUrl}
      alt="provider-profile-pic" 
      className={`${profilePic} ${className}`}
      style={{
        ...customStyles,
        cursor: onClick ? 'pointer' : 'auto',
      }}
      onClick={onClick}
    />
  ) : (
    <div
      style={customStyles}
    />
  );
}

const styles = () => ({
  profilePic: {
    height: '100px',
    margin:'0 20px 0 20px',
    borderRadius: '4px',   
  }
});

export default withStyles(styles)(Avatar);